import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import Button from 'components/common/Button';
import IconFile from 'components/icons/IconFile';

const styles = theme => ({
  root: {
    width: 500,
    margin: '0 auto',
    padding: 25,
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      padding: '8px 8px',
    },
  },
  icon: {
    width: 54,
    margin: '0 auto',
    position: 'relative',
    marginBottom: 15,
  },
  iconFile: {
    width: 54,
    height: 68,
  },
  iconTypography: {
    position: 'absolute',
    top: 38,
    left: 2,
    width: 34,
  },
  button: {
    marginTop: 30,
  },
});

const DocumentsViewDefault = props => (
  <Paper className={props.classes.root}>
    <div className={props.classes.icon}>
      <IconFile className={props.classes.iconFile} />
      <Typography
        className={props.classes.iconTypography}
        variant="caption"
        color="secondary"
        align="center"
      >
        .{props.extension}
      </Typography>
    </div>
    <Typography variant="subheading" color="secondary" gutterBottom>
      Preview is not possible.<br />
      Please, download this file to your computer
    </Typography>
    <Button
      className={props.classes.button}
      variant="raised"
      color="primary"
      href={props.src}
      download={props.src}
    >
      Download
    </Button>
  </Paper>
);

DocumentsViewDefault.propTypes = {
  src: PropTypes.string.isRequired,
  extension: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    iconFile: PropTypes.string.isRequired,
    iconTypography: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(DocumentsViewDefault);



// WEBPACK FOOTER //
// ./src/components/common/DocumentsViewDialog/DocumentsViewDefault.js